import imageCompression from 'browser-image-compression';

export async function compressImage(file) {
	  const options = {
						    maxSizeMB: 0.2			,
						    maxWidthOrHeight: 1600	,
						    useWebWorker: true
					  };

  return await imageCompression(file, options)	;
}

$(function () {
	$(document).on('change', '#party_order_images', async function() {
		console.log("FILES SELECTED");
			
		const input = this						;
		const originalFiles = input.files		;
	 	const dataTransfer = new DataTransfer()	;
		
		// COMPRESS FILES
		for(var i = 0 ; i < originalFiles.length; i++){
			const originalFile	=	originalFiles[i]									;
			console.log('Original:',(originalFile.size / 1024).toFixed(0),'KB')		;
		 	const compressedFile = await compressImage(originalFile)				;
		  	console.log('Compressed:',(compressedFile.size / 1024).toFixed(0),'KB')	;
			dataTransfer.items.add(
					new File([compressedFile],originalFile.name,{type: compressedFile.type,lastModified: Date.now()})
			);
		}
	 	
	 	

		console.log("FILE COMPRESSION COMPLETE");
		input.files = dataTransfer.files	;
	});
});